import { render, staticRenderFns } from "./ExpandOnHover.vue?vue&type=template&id=b5aff62a&"
import script from "./ExpandOnHover.vue?vue&type=script&lang=js&"
export * from "./ExpandOnHover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports